import { CircularProgress } from "@mui/material";
import Grid from "@mui/material/Grid2";
import React from "react";
import { Color, ColorSAP, FONT_FAMILY, Separator, Typography } from "../../ontego-ui";
import Chip from "../Chip/Chip";
import TertiaryButton from "../TertiaryButton/TertiaryButton";
import Styled from "./SystemMessageStyles";

const SystemMessageList = (props) => {
    const { id, log = [], style } = props

    return (
        <Styled.SystemMessageList style={style}>
            <Grid container spacing={1} style={{ width: "100%" }}>
                <Grid item size={{ md: 2 }} style={{ textAlign: "center" }}>
                    <Chip
                        backgroundColor={ColorSAP.neutral[80]}
                        color={Color.neutral[0]}
                        smallPadding
                    >
                        {log.log_type}
                    </Chip>
                </Grid>
                <Grid item size={{ md: 8 }}>
                    <Typography
                        id={`${id}-system-message`}
                        fontFamily={FONT_FAMILY.PLUS_JAKARTA_SANS_REGULAR}
                        size={14}
                        color={ColorSAP.neutral[100]}
                        style={{ width: '100%' }}
                    >
                        {log.messages}
                    </Typography>
                </Grid>
                <Grid item size={{ md: 2 }}>
                    <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'right' }}>
                        <Typography
                            id={`${id}-system-message-date`}
                            fontFamily={FONT_FAMILY.PLUS_JAKARTA_SANS_MEDIUM}
                            size={10}
                            color={ColorSAP.neutral[100]}
                            style={{ marginBottom: 4 }}
                        >
                            {log.date}
                        </Typography>
                        <Typography
                            id={`${id}-system-message-time`}
                            fontFamily={FONT_FAMILY.PLUS_JAKARTA_SANS_MEDIUM}
                            size={10}
                            color={ColorSAP.neutral[100]}
                        >
                            {log.time}
                        </Typography>
                    </div>
                </Grid>
            </Grid>
        </Styled.SystemMessageList>
    )
}

export const SystemMessage = (props) => {
    const { id, log = [], style, systemMessageListStyle, textSystemMessages = 'System Messages', handleViewMore, textViewMore = 'View More', isLoading } = props

    return (
        <Styled.SystemMessageContainer
            id={id}
            style={{
                position: 'relative',
                ...style
            }}
        >
            <Styled.SystemMessageHeaderContainer>
                <Typography
                    id={`${id}-system-message-title`}
                    fontFamily={FONT_FAMILY.PLUS_JAKARTA_SANS_BOLD}
                    size={24}
                    color={ColorSAP.neutral[100]}
                >
                    {textSystemMessages}
                </Typography>
                {handleViewMore &&
                    <TertiaryButton
                        theme="primary"
                        size="small"
                        onClick={handleViewMore}
                    >
                        {textViewMore}
                    </TertiaryButton>
                }
            </Styled.SystemMessageHeaderContainer>

            <Styled.SystemMessageListContainer id={`${id}-system-message-container`}>
                {isLoading ? (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', marginTop: 120 }}>
                        <CircularProgress size={68} thickness={4} style={{ color: ColorSAP.neutral[70] }} />
                    </div>
                ) : (
                    <>
                        {log.map((l, index) => (
                            <React.Fragment key={`l${index}`}>
                                <SystemMessageList
                                    key={`${l.messages}-${index}`}
                                    id={`${id}-${index}`}
                                    log={l}
                                    style={systemMessageListStyle}
                                />
                                {index !== log.length - 1 && <Separator type="n100" />}
                            </React.Fragment>
                        ))}
                    </>
                )}
            </Styled.SystemMessageListContainer>
        </Styled.SystemMessageContainer>
    )
}

export default React.memo(SystemMessage)